<div class="screen-location">
  {{ screen().ville }} - {{ screen().nom_cinema }}
</div>
<div class="screen-details">
  {{
    'screen.header' | translate: {
      nomSalle: screen().nom_salle,
      capacite: screen().capacite || ''
    }
  }}
  @if (hasComments()) {
    <ng-container>
      <i class="bi bi-chat-left-dots-fill comment-text"
         (click)="openCommentModal()"
         title="{{ 'tooltip.existingCommentWeek' | translate }}"
      >
      </i>
    </ng-container>
  }
  @else {
    <ng-container>
      <i class="bi bi-plus-circle comment-text"
         (click)="openCommentModal()"
         title="{{ 'tooltip.addComment' | translate }}"
      >
      </i>
    </ng-container>
  }
</div>
<div class="screen-announcement">
  @if (data().prog_annonce[screen().id_cinema]) {
    <ng-container>
      {{ 'screen.announcedUntil' | translate: { annonceDate: data().prog_annonce[screen().id_cinema] } }}
    </ng-container>
  }
  @else {
    <ng-template>
      <span class="announcement-placeholder"></span>
    </ng-template>
  }
</div>
